<template>
  <div>
    <div class="card-body">
        <b-table show-empty :items="$route.params.permissions" :fields="fields" v-if="$route.params.permissions">
      </b-table>
    </div>
  </div>
</template>
<script>
export default {
    name: 'permissions',
    data () {
      return {
        fields: [
          { key: 'tag', label: 'Tag', sortable: true },
        ]
      }
    }
}
</script>